import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import ContentLoader from 'react-content-loader';

const Header = () => {
  const themeContext = useContext(ThemeContext);
  return (
    <ContentLoader
      backgroundColor={themeContext?.loadingTableColor}
      foregroundColor={themeContext?.loadingTableColorLight}
      backgroundOpacity={1}
      foregroundOpacity={0.5}
      width="100%"
      height="40"
      speed={1.2}
      preserveAspectRatio="xMinYMin"
    >
      <rect x="0" y={0} rx="5" ry="5" width="120" height="20" />
      <rect x="220" y={0} rx="5" ry="5" width="100" height="20" />
      <rect x="45%" y={0} rx="5" ry="5" width="150" height="20" />
      <rect x="65%" y={0} rx="5" ry="5" width="100" height="20" />
      <rect x="80%" y={0} rx="5" ry="5" width="150" height="20" />
    </ContentLoader>
  );
};
const Table = () => {
  const themeContext = useContext(ThemeContext);
  return (
    <ContentLoader
      backgroundColor={themeContext?.loadingTableColor}
      foregroundColor={themeContext?.loadingTableColorLight}
      backgroundOpacity={1}
      foregroundOpacity={0.5}
      width="100%"
      height="95%"
      speed={1.2}
      preserveAspectRatio="xMinYMin"
    >
      {Array(10)
        .fill('')
        .map((e, row) => (
          <React.Fragment key={row}>
            <rect
              key={row}
              x="10"
              y={150 * row}
              rx="10"
              ry="10"
              width="200"
              height="100"
            />
            <rect
              x="220"
              y={20 + 150 * row}
              rx="5"
              ry="5"
              width="100"
              height="10"
            />
            <rect
              x="220"
              y={40 + 150 * row}
              rx="5"
              ry="5"
              width={Math.random() * (300 - 100) + 100}
              height="10"
            />
            <rect
              x="220"
              y={60 + 150 * row}
              rx="5"
              ry="5"
              width={Math.random() * (180 - 100) + 100}
              height="10"
            />
            <rect
              x="45%"
              y={30 + 150 * row}
              rx="5"
              ry="5"
              width="200"
              height="10"
            />
            <rect
              x="45%"
              y={50 + 150 * row}
              rx="5"
              ry="5"
              width="170"
              height="10"
            />
            <rect
              x="65%"
              y={40 + 150 * row}
              rx="5"
              ry="5"
              width="100"
              height="10"
            />
            <rect
              x="80%"
              y={30 + 150 * row}
              rx="5"
              ry="5"
              width={Math.random() * (300 - 100) + 100}
              height="10"
            />
            <rect
              x="80%"
              y={50 + 150 * row}
              rx="5"
              ry="5"
              width={Math.random() * (300 - 100) + 100}
              height="10"
            />
            {/* <rect
              x="40%"
              y={5 + 50 * row}
              rx="5"
              ry="5"
              width="120"
              height="30"
            />
            <rect
              x="50%"
              y={20 + 50 * row}
              rx="5"
              ry="5"
              width="50"
              height="10"
            />
            <rect
              x="55%"
              y={20 + 50 * row}
              rx="5"
              ry="5"
              width="50"
              height="10"
            />
            <rect
              x="60%"
              y={20 + 50 * row}
              rx="5"
              ry="5"
              width={Math.random() * (100 - 50) + 50}
              height="10"
            />
            <rect
              x="70%"
              y={20 + 50 * row}
              rx="5"
              ry="5"
              width="100"
              height="10"
            />
            <circle cx="83%" cy={25 + 50 * row} r="22" />
            <circle cx="88%" cy={25 + 50 * row} r="17" />
            <circle cx="92%" cy={25 + 50 * row} r="17" />
            <circle cx="95%" cy={25 + 50 * row} r="17" />
            <circle cx="98%" cy={25 + 50 * row} r="17" /> */}
          </React.Fragment>
        ))}
    </ContentLoader>
  );
};

const Loader = () => {
  return (
    <div style={{ padding: '1rem', height: '100%' }}>
      <Header />
      <Table />
    </div>
  );
};

export default Loader;
